import styled from 'styled-components';

export const StyledSubscriptionEndingModalLogo = styled.div`
   padding-top: 10px;
`;
StyledSubscriptionEndingModalLogo.displayName = 'StyledSubscriptionEndingModalLogo';
